// Animation logic for like button
const LIKE_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <g clip-path="url(#clip0_3322_14358)">
      <path d="M7.82007 6.59571C7.83087 7.08917 7.48003 7.5167 6.99395 7.6024L2.58653 8.37955C2.22394 8.44349 1.87816 8.20137 1.81423 7.83878L1.40905 5.54089C1.34511 5.1783 1.58723 4.83252 1.94982 4.76859L2.7213 4.63256C2.85102 4.60968 2.95511 4.51255 2.9869 4.38472L3.6838 1.58178C3.70993 1.4767 3.79548 1.39687 3.90211 1.37807C4.34916 1.29924 4.77547 1.59775 4.8543 2.0448L5.05887 3.20495C5.09083 3.38625 5.26372 3.50731 5.44502 3.47534L6.595 3.27257C7.19857 3.16614 7.755 3.62276 7.76841 4.23549L7.82007 6.59571Z" fill="#0ba85e"/>
    </g>
    <defs>
      <clipPath id="clip0_3322_14358">
        <rect width="8" height="8" fill="white" transform="translate(0 1.38916) rotate(-10)"/>
      </clipPath>
    </defs>
  </svg>
`;

const createSubIcon = (className: string): HTMLDivElement => {
  const icon = document.createElement('div');
  icon.classList.add('likes-counter__float-icon--sub', className);
  icon.innerHTML = LIKE_SVG;
  return icon;
};

const createFloatingIcon = (className: string): HTMLDivElement => {
  const icon = document.createElement('div');
  icon.classList.add('likes-counter__float-icon', className);
  icon.innerHTML = LIKE_SVG;

  // Add sub icons
  const sub1 = createSubIcon('sub-1');
  const sub2 = createSubIcon('sub-2');
  icon.appendChild(sub1);
  icon.appendChild(sub2);

  return icon;
};

export const forumLikeAnimation = (button: HTMLElement): void => {
  // Check if this is a logged-in user's button (has data attributes instead of href)
  const isLoggedIn = button.hasAttribute('data-like-comment') && button.hasAttribute('data-thread-id');
  
  // Check if we're adding or removing the like
  const isRemoving = button.classList.contains('likes-counter__icon-button--counted');

  // If not logged in, no animation
  if (!isLoggedIn) return;

  if (isRemoving) {
    // Unlike animation
    button.classList.add('unlike-animation');
    setTimeout(() => {
      button.classList.remove('unlike-animation');
    }, 500);
    return;
  }

  // Like animation
  let addJustLikedClass = true;
  
  if (button.classList.contains('just-liked')) {
    button.classList.remove('just-liked');
    addJustLikedClass = false;
  }

  // Create and append floating icons
  const floatIcon1 = createFloatingIcon('likes-counter__float-icon--1');
  const floatIcon2 = createFloatingIcon('likes-counter__float-icon--2');
  button.appendChild(floatIcon1);
  button.appendChild(floatIcon2);

  // Add animation class
  if (addJustLikedClass) {
    button.classList.add('just-liked');
  }

  // Cleanup after animation
  setTimeout(() => {
    floatIcon1.remove();
    floatIcon2.remove();
    button.classList.remove('just-liked');
  }, 1000);
};